import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Table, Pagination, Select } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import moment from "moment";

const ConsumerTransactions = () => {
  const [pageDetails, setPageDetails] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [phone, setPhone] = useState("");
  const [orderId, setOrderId] = useState("");

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (createdAt) => moment(createdAt).format("DD-MM-YYYY, h:mm:ss a"),
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
    },
    {
      title: "Shop Name",
      render: (text, record) => record?.shop?.name,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Note",
      dataIndex: "notes",
    },
  ];

  let roleId = Helper.UserRole();

  useEffect(() => {
    try {
      (async () => {
        setLoading(true);
        const data = await axios
          .get("/consumer-transaction-list", {
            params: {
              limit,
              page,
              status: status,
              phoneNumber: phone,
              orderId: orderId,
              roleId,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setCount(data.data.count);
          setLoading(false);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [limit, page, status, phone, orderId]);

  const handleChange = (value) => {
    setPage(1);
    setLimit(value);
  };

  return (
    <Container fluid>
      <div className="order-pg">
        <Row>
          <Col lg={12}>
            <div className="order-pg-cards mt-2">
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by Number"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by Order ID"
                  value={orderId}
                  onChange={(e) => {
                    setOrderId(e.target.value);
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <Select
                  defaultValue="All"
                  style={{ width: "96%", height: "100%" }}
                  onChange={(input) => setStatus(input)}
                  value={status}
                  options={[
                    { value: "", label: "All" },
                    { value: "credit", label: "Credit" },
                    { value: "debit", label: "Debit" },
                  ]}
                />
              </div>
            </div>
          </Col>
          <Col md={12}>
            <div className="orders-list">
              <Table
                columns={columns}
                dataSource={pageDetails}
                pagination={false}
                rowKey="id"
                loading={loading}
              />
              <div className="pagination">
                <Select
                  defaultValue={limit}
                  style={{ width: 120 }}
                  onChange={handleChange}
                  options={[
                    {
                      value: 5,
                      label: "5",
                    },
                    {
                      value: 10,
                      label: "10",
                    },
                    {
                      value: 20,
                      label: "20",
                    },
                    {
                      value: 50,
                      label: "50",
                    },
                    {
                      value: 100,
                      label: "100",
                    },
                  ]}
                />
                {loading === false && (
                  <Pagination
                    defaultCurrent={page}
                    pageSize={limit}
                    showSizeChanger={false}
                    total={count}
                    onChange={setPage}
                  />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ConsumerTransactions;
